/** Research guide §2 — Starting a research request (`research/IntakeForm.tsx`). */
import { helpSectionMeta } from '../help-sections.js';
import { Btn, Bullets, Callout, HelpSectionCard, Li, P, Shot, SubHead } from '../HelpPrimitives.js';

export function ResearchIntake(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('research-intake')}>
      <Shot slug="research-intake" caption="The intake form for a new research request." />
      <P>
        The intake form covers the client, targeting, company size &amp; type, reference &amp;
        exclusion companies, grading criteria and purpose, a free-text brief, and a{' '}
        <Btn>target count</Btn> slider for how many companies you want.
      </P>

      <SubHead>Three buttons, three different things</SubHead>
      <Bullets>
        <Li>
          <Btn>Parse &amp; autofill</Btn> — the one AI call on this screen. Paste a brief and it
          fills in the form fields for you. It only runs when you click it.
        </Li>
        <Li>
          <Btn>Save draft</Btn> — keeps your work without starting anything.
        </Li>
        <Li>
          <Btn>Run research</Btn> — creates the request and starts the free discovery pass that
          builds your long-list. Nothing here spends an AI-check credit yet.
        </Li>
      </Bullets>

      <Callout title="Nothing fires on its own">
        <P>
          Opening this form does not call the AI. Both <Btn>Parse &amp; autofill</Btn> and{' '}
          <Btn>Run research</Btn> need their own explicit click.
        </P>
      </Callout>
    </HelpSectionCard>
  );
}
